(() => {
  if (customElements.get('mn-footer-navigation')) return;

  class MarinaFooterNavigation extends HTMLElement {
    connectedCallback() {
      this.disclosures = [...this.querySelectorAll('[data-mn-footer-disclosure]')];
      this.desktop = window.matchMedia('(min-width: 700px)');
      this.applyViewport = () => {
        this.disclosures.forEach((disclosure) => {
          const summary = disclosure.querySelector('summary');
          disclosure.open = this.desktop.matches || disclosure.contains(document.activeElement);
          if (this.desktop.matches) {
            summary.setAttribute('aria-disabled', 'true');
            summary.setAttribute('tabindex', '-1');
          } else {
            summary.removeAttribute('aria-disabled');
            summary.removeAttribute('tabindex');
          }
        });
      };
      this.handleClick = (event) => {
        if (this.desktop.matches && event.target.closest('.mn-footer__summary')) event.preventDefault();
      };
      this.handleBlockSelect = (event) => {
        const disclosure = event.target.closest('[data-mn-footer-disclosure]');
        if (disclosure && this.contains(disclosure)) disclosure.open = true;
      };
      this.applyViewport();
      this.desktop.addEventListener('change', this.applyViewport);
      this.addEventListener('click', this.handleClick);
      this.addEventListener('shopify:block:select', this.handleBlockSelect);
    }

    disconnectedCallback() {
      this.desktop?.removeEventListener('change', this.applyViewport);
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }
  }

  customElements.define('mn-footer-navigation', MarinaFooterNavigation);
})();
